<template>
  <div
    class="flex justify-between mb-6 items-center border-b-2 border-gray-700 dark:border-gray-400 pb-4"
    
  >
    <div class="flex-col">
      <div class="flex">
        <p class="text-textBlack dark:text-textWhite text-base">
          {{ $t("invoice_type") }} :
        </p>
        <p class="text-textBlack dark:text-textWhite text-base font-semibold">
          {{ $t(invoice_type) }}
        </p>
      </div>
      <div class="flex">
        <p class="text-textBlack dark:text-textWhite text-base">
          {{ $t("admin") }} :
        </p>
        <p class="text-textBlack dark:text-textWhite text-base">
          {{ $store.getters["user"].name }}
        </p>
      </div>
    </div>
    <div class="flex flex-col items-center">
      <img
        src="../../assets/logo.png"
        alt=""
        width="180"
        height="180"
        v-if="
          $store.getters['currentSettingWiseManager'].set_logo == '' ||
          $store.getters['currentSettingWiseManager'].set_logo == null
        "
      /><img
        :src="
          $store.getters['fileUrl'] +
          $store.getters['currentSettingWiseManager'].set_logo
        "
        alt=""
        width="180"
        height="180"
      />
      <p
        class="text-textBlack3 dark:text-textWhite3 text-2xl font-semibold mt-2"
      >
        {{ $store.getters["currentSettingWiseManager"].app_name }}
      </p>
    </div>

    <div class="flex-col">
      <div class="flex">
        <p class="text-textBlack dark:text-textWhite text-base">
          {{ $t("date") }} :
        </p>
        <p class="text-textBlack dark:text-textWhite text-base">
          {{ $store.getters["date"] }}
        </p>
      </div>

      <div class="flex">
        <p class="text-textBlack dark:text-textWhite text-base">
          {{ $t("time") }} :
        </p>
        <p class="text-textBlack dark:text-textWhite text-base">
          {{ $store.getters["time"] }}
        </p>
      </div>
    </div>
  </div>
  <div class="h-5"></div>
</template><script setup>
import { defineProps } from "vue";

defineProps({
    invoice_type: {
    type: [String],
    default: "",
  },
});
</script>
